import request from '@/utils/request';
import { useFd } from '@/utils/formData';
/**
 * AEW Client Lessons API For Index
 */
export function searchLessonList({ column, kw = "", page = 1 }) {
  const formData = useFd('AEW/Client/LessonList', { page })
  if (column) {
    formData.append('search[column]', column)
    formData.append('search[kw]', kw || "")
  }
  return request({
    method: 'post',
    data: formData
  });

}

export function fetchLesson({ projectId, lessonId, dbId = 2 }) {
  const formData = useFd('AEW/Client/LessonDetail', {
    'project_id': projectId,
    'lesson_id': lessonId,
    '__dbid_origin': dbId
  })
  return request({
    method: 'post',
    data: formData
  });
}



// WEBPACK FOOTER //
// ./src/api/client/Lesson.js